import React from 'react'
import { FREQUENCY_VALUES } from '../_utils/constants'
import { ScheduleFormData } from '../_utils/types'
import { ScheduleBaseDialog } from './base-dialog'
import { useCreateScheduleMutation } from '@/hooks/api/use-create-schedule-mutation'
import { toast } from '@/components/ui/toaster'
import { useTranslate } from '@tolgee/react'

type ScheduleAddDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  agentId?: string
}

export function ScheduleAddDialog(props: ScheduleAddDialogProps) {
  const { open, onOpenChange, agentId } = props
  const createScheduleMutation = useCreateScheduleMutation()
  const { t } = useTranslate()

  const onSubmit = async (values: ScheduleFormData) => {
    await createScheduleMutation.mutateAsync({
      agentId: values.agentId,
      startDate: values.startDate!,
      endDate: values.endDate,
      startTime: values.startTime,
      frequency: values.frequency,
      parameters: values?.parameters,
    })
    toast.success(t('schedule.dialogs.add.toast.success'))
    onOpenChange(false)
  }

  return (
    <ScheduleBaseDialog
      open={open}
      onOpenChange={onOpenChange}
      title={t('schedule.dialogs.add.title')}
      actionTitle={t('schedule.dialogs.add.actionTitle')}
      handleSubmit={onSubmit}
      isSubmitting={createScheduleMutation.isPending}
      initialValues={{
        agentId: agentId || '',
        toolId: '',
        startDate: new Date(),
        endDate: undefined,
        startTime: '',
        frequency: FREQUENCY_VALUES?.DAILY,
      }}
    />
  )
}
